import { createContext } from "react";

/* Creating a context for the user. */
export const UsuarioContext = createContext({
    tipo:null,
    imagen:null,
});